import React from 'react';
import Modal from 'react-bootstrap/Modal';
import type { GenericList } from './models/JobSharedInterfaces';
import { toast } from 'react-toastify';
import { GetQuery, PostQuery } from './Shared';

interface CancelJobProps {
    jobId: number;
    showModal: boolean;
    hideModal(): void;
    saveModal(): void;
}

const CancelJobPopup = (props: CancelJobProps) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [cancelReasonOptions, setCancelReasonOptions] = React.useState<GenericList[]>([]);
    const [cancelReasonId, setCancelReasonId] = React.useState(-1);

    React.useEffect(() => {
        if (props.showModal) {
            getData();
        }
    }, [props.showModal]);

    const getData = async () => {
        const apiUrl = "GetCancelReasons";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setCancelReasonOptions(result.data);
            setLoading(false);
        }
    }

    const saveCancel = () => {
        let errorList: any = {};
        if (cancelReasonId < 1) {
            errorList["cancelReasonId"] = "Please select a reason";
            setErrors(errorList);
        } else {
            saveCancelJob();
        }
    }

    const saveCancelJob = async () => {
        setErrors({});

        var cancelJob = {
            jobId: props.jobId,
            cancelReasonId: cancelReasonId
        };

        var jsonItem = JSON.stringify(cancelJob);

        const apiUrl = "CancelJob";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errorList = result.data.messages as any[];
                errorList.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                props.saveModal();
            }
        }
    }

    const renderDetails = (
        <Modal aria-labelledby="contained-modal-title-sm" show={props.showModal} onHide={props.hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Cancel Job</Modal.Title>
                <button type="button" className="close" onClick={props.hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <label className="input-group" htmlFor="cancelReasonId">
                    <span className="label">Cancel Reason</span>
                    <select className="select fullWidth" id="cancelReasonId" name="cancelReasonId" value={cancelReasonId} onChange={(e) => { setErrors({}), setCancelReasonId(Number(e.target.value))}}>
                        <option hidden defaultValue="-1"></option>
                        {cancelReasonOptions.map(reason =>
                            <option key={reason.id} value={reason.id}>{reason.name}</option>
                        )};
                    </select>
                </label>
                <span className="label errors">{errors["cancelReasonId"]}</span>
            </Modal.Body>

            <Modal.Footer>
                <button className="popup-button--yes" onClick={saveCancel}>Save</button>
            </Modal.Footer>
        </Modal>
    );

    let contents = props.showModal ? loading
        ? <p><em>Loading...</em></p>
        : renderDetails : "";

    return (
        <div>
            {contents}
        </div>
    );
}

export default CancelJobPopup;